import { gql } from '@apollo/client';

export const SONGPOP_MAESTRO_DROP_FRAGMENT = gql`
  fragment SongpopMaestroDropFragment on SongpopMaestroDropConfig {
    id
    name
    status
    startDate
    stopDate
    capEnabled
    capSeats
    seatsSold
    skuId
    priceUsd
    priceUsdBase
    offerPercentage
    instantRewards {
      type
      amount
      itemId
    }
    notifSchedule {
      anchor
      offsetHours
      title
      body
      fireDate
      sent
      repeatEveryHours
      occurrenceCount
      lastSentAt
      nextFireDate
      filterUserIds
      filterSubscriptionTier
      filterUserMinCreationDate
      filterUserMaxCreationDate
      filterAppVersion
      filterAppVersionOperator
      filterUserLevel
      filterExcludedUserIds
      filterHadSub
      filterSpendTiers
    }
    created
    updatedAt

    filterUserIds
    filterSubscriptionTier
    filterUserMinCreationDate
    filterUserMaxCreationDate
    filterAppVersion
    filterAppVersionOperator
    filterUserLevel
    filterExcludedUserIds
    filterHadSub
    filterSpendTiers
  }
`;

export const SONGPOP_MAESTRO_SKU_OPTIONS_FRAGMENT = gql`
  fragment SongpopMaestroSkuOptionFragment on SongpopMaestroSkuOption {
    id
    cost
    iosSku
    androidSku
    iosPlaceholder
    androidPlaceholder
    retired
  }
`;

export const SONGPOP_MAESTRO_DROPS_QUERY = gql`
  query getSongpopMaestroDrops {
    liveOps {
      songpopMaestroDrops {
        ...SongpopMaestroDropFragment
      }
      songpopMaestroSkus {
        ...SongpopMaestroSkuOptionFragment
      }
    }
  }
  ${SONGPOP_MAESTRO_DROP_FRAGMENT}
  ${SONGPOP_MAESTRO_SKU_OPTIONS_FRAGMENT}
`;

export const CREATE_SONGPOP_MAESTRO_DROP = gql`
  mutation createSongpopMaestroDrop($input: CreateSongpopMaestroDropInput!) {
    createSongpopMaestroDrop(input: $input) {
      ...SongpopMaestroDropFragment
    }
  }
  ${SONGPOP_MAESTRO_DROP_FRAGMENT}
`;

export const UPDATE_SONGPOP_MAESTRO_DROP = gql`
  mutation updateSongpopMaestroDrop($input: UpdateSongpopMaestroDropInput!) {
    updateSongpopMaestroDrop(input: $input) {
      ...SongpopMaestroDropFragment
    }
  }
  ${SONGPOP_MAESTRO_DROP_FRAGMENT}
`;

export const DELETE_SONGPOP_MAESTRO_DROP = gql`
  mutation deleteSongpopMaestroDrop($id: ID!) {
    deleteSongpopMaestroDrop(id: $id)
  }
`;

// "Send now": one saved push of a running event goes out right away (in the background).
export const FORCE_SEND_SONGPOP_MAESTRO_PUSH = gql`
  mutation forceSendSongpopMaestroPush($dropId: ID!, $index: Int!) {
    forceSendSongpopMaestroPush(dropId: $dropId, index: $index)
  }
`;

// Next time-limited event: a DRAFT copy of the latest one.
export const START_NEW_SONGPOP_MAESTRO_EVENT = gql`
  mutation startNewSongpopMaestroEvent($name: String!) {
    startNewSongpopMaestroEvent(name: $name) {
      ...SongpopMaestroDropFragment
    }
  }
  ${SONGPOP_MAESTRO_DROP_FRAGMENT}
`;

export const SONGPOP_MAESTRO_CONFIG_QUERY = gql`
  query getSongpopMaestroConfig {
    liveOps {
      songpopMaestroConfig {
        availableForKids
        availableForNonKids
        perksEnabled
        perks
        instantRewards {
          type
          amount
          itemId
        }
        foundersWallEnabled
        foundersWallShowKids
        hiddenBenefits
        benefitOrder
      }
      songpopMaestroPerkFields {
        key
        kind
        default
        min
        max
        allowUnlimited
      }
    }
  }
`;

export const SONGPOP_MAESTRO_FEATURE_QUERY = gql`
  query getSongpopMaestroFeature {
    liveOps {
      songpopMaestroConfig {
        enabled
      }
    }
  }
`;

export const UPDATE_SONGPOP_MAESTRO_CONFIG = gql`
  mutation updateSongpopMaestroConfig($input: SongpopMaestroConfigInput!) {
    updateSongpopMaestroConfig(input: $input) {
      enabled
      availableForKids
      availableForNonKids
      perksEnabled
      perks
      foundersWallEnabled
      foundersWallShowKids
      hiddenBenefits
      benefitOrder
    }
  }
`;
